import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoOrderingDoctorListTemplate } from 'themes/application/niko-ordering-doctor/pages';
import { NikoOrderingDoctorListViewStore } from '../stores';

@setCurrentView((rootStore) => new NikoOrderingDoctorListViewStore(rootStore), 'nikoOrderingDoctorListViewStore')
@observer
class NikoOrderingDoctorList extends React.Component {
    render() {
        return <NikoOrderingDoctorListTemplate {...this.props} />
    }
}

export default NikoOrderingDoctorList;